import React, { useContext, useEffect, useState } from "react";

import "./stylesCasino.css";
import Layout from "../CommonComponents/Layout/Layout";

import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import CustomDatePicker from "../CommonComponents/CustomDatePicker/CustomDatePicker";
import dayjs from "dayjs";
import CasinoKPI from "./CasinoKPI/CasinoKPI";
import ProvidersList from "./ProvidersList/ProvidersList";
import GamesList from "./GamesList/GamesList";

function Casino() {
  const { setActiveSidebarTab } = useContext(AppContext);

  const tabs = ["Casino KPI", "Providers List", "Games List"];
  const todayRange = [dayjs(), dayjs()];

  const [activeTab, setActiveTab] = useState("Casino KPI");
  const [sportsBookDates, setSportsBookDates] = useState(todayRange);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.CASINO, "Casino");
  }, [setActiveSidebarTab]);

  return (
    <Layout>
      <div className="casino-container">
        <div className="casino">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Casino</p>
              </div>
              <CustomDatePicker
                getData={() => {}}
                dates={sportsBookDates}
                setDates={setSportsBookDates}
                showQuickSelect={true}
                showPresets={true}
              />
            </div>
            <div className="dashboard-tabs">
              {tabs.map((tab) => (
                <button
                  className={activeTab === tab ? "active" : null}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            {activeTab === "Casino KPI" && <CasinoKPI />}
            {activeTab === "Providers List" && <ProvidersList />}
            {activeTab === "Games List" && <GamesList />}
          </>
        </div>
      </div>
    </Layout>
  );
}

export default Casino;
